var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "matter-log" },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "switch",
          on: { change: _vm.handleClick },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _vm.getSite.hasInterim
            ? _c("el-radio-button", { attrs: { label: "1" } }, [
                _vm._v(_vm._s(_vm.$t("COMMON_INTERIM"))),
              ])
            : _vm._e(),
          _c("el-radio-button", { attrs: { label: "2" } }, [
            _vm._v(_vm._s(_vm.$t("COMMON_FINAL"))),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active == "1",
              expression: "active=='1'",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "wl-table",
          attrs: {
            data: _vm.initData.interimMatterLogList,
            height: "300px",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChangeInterim },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "40" } }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              align: "center",
              width: "100px",
              "show-overflow-tooltip": "",
              label: _vm.$t("TABLE_HEADER_matter"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "entityList",
              align: "center",
              label: _vm.$t("TABLE_HEADER_entityList"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.entityList, function (item, index) {
                    return _c("span", { key: index }, [
                      index == scope.row.entityList.length - 1
                        ? _c("span", [_vm._v(_vm._s(item.entityName))])
                        : _c("span", [_vm._v(_vm._s(item.entityName) + "/")]),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "category",
              align: "center",
              width: "130px",
              label: _vm.$t("TABLE_HEADER_category"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Issues"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD001")
                      ? [
                          _c(
                            "el-dropdown",
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Deficiency"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD002")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Adjustment"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD003")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Difference"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD004")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active == "2",
              expression: "active=='2'",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "wl-table",
          attrs: {
            data: _vm.initData.finalMatterLogList,
            height: "300px",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChangeFinal },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "40" } }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              align: "center",
              width: "100px",
              "show-overflow-tooltip": "",
              label: _vm.$t("TABLE_HEADER_matter"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "entityList",
              align: "center",
              label: _vm.$t("TABLE_HEADER_entityList"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.entityList, function (item, index) {
                    return _c("span", { key: index }, [
                      index == scope.row.entityList.length - 1
                        ? _c("span", [_vm._v(_vm._s(item.entityName))])
                        : _c("span", [_vm._v(_vm._s(item.entityName) + "/")]),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "category",
              align: "center",
              width: "130px",
              label: _vm.$t("TABLE_HEADER_category"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Issues"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD001")
                      ? [
                          _c(
                            "el-dropdown",
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Deficiency"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD002")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Adjustment"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD003")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "typeDesc",
              align: "center",
              label: _vm.$t("TABLE_HEADER_Difference"),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.showIcon(scope.row, "MLTD004")
                      ? [
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _c("i", {
                                  class: _vm.showStatus(scope.row),
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleVisible(scope)
                                    },
                                  },
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  staticClass: "wl-solt-menu-item",
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    [
                                      _c("pop-hover", {
                                        attrs: {
                                          data: {
                                            row: scope.row,
                                            status: _vm.statusDict,
                                            priority: _vm.priority,
                                          },
                                          showBtn: false,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "checked-bottom" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.clientModel,
                callback: function ($$v) {
                  _vm.clientModel = $$v
                },
                expression: "clientModel",
              },
            },
            [_vm._v(_vm._s(_vm.$t("PAGE_NEXTYEAR_CLIENT_TITLE")))]
          ),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.KPMGModel,
                callback: function ($$v) {
                  _vm.KPMGModel = $$v
                },
                expression: "KPMGModel",
              },
            },
            [_vm._v(_vm._s(_vm.$t("PAGE_KPMG_TEAM_TITLE")))]
          ),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.insights,
                callback: function ($$v) {
                  _vm.insights = $$v
                },
                expression: "insights",
              },
            },
            [_vm._v(_vm._s(_vm.$t("PAGE_NEXTYEAR_INSIGHT_TITLE")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }